<template>
  <div
    class="my-7 overflow-hidden md:mb-12 lg:mb-20"
    :class="paragraphClassList"
  >
    <Container>
      <BlokkliField :list="header" name="field_header" />
    </Container>
    <div class="relative">
      <BlokkliField
        v-if="isSlider"
        v-slot="{ items }"
        name="field_paragraphs_teaser"
        :list="paragraphs"
        proxy-mode
      >
        <ParagraphTeaserListSlider
          :slides="items"
          :class="{
            'pointer-events-none': isEditing,
          }"
        />
      </BlokkliField>
      <BlokkliField
        v-else-if="paragraphs && paragraphs.length && paragraphs.length < 3"
        name="field_paragraphs_teaser"
        :list="paragraphs"
        class="paragraph-teaser-flex flex flex-row flex-wrap justify-center container gap-gap mx-auto"
      />
      <BlokkliField
        v-else
        name="field_paragraphs_teaser"
        :list="paragraphs"
        class="paragraph-teaser-grid container mx-auto"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphTeaserListFragment } from '#graphql-operations'

defineProps<{
  header?: ParagraphTeaserListFragment['header']
  paragraphs?: ParagraphTeaserListFragment['paragraphs']
}>()

const { options, isEditing } = defineBlokkli({
  bundle: 'teaser_list',
  options: {
    teaserStyle: {
      type: 'radios',
      label: 'Darstellung',
      default: 'grid',
      displayAs: 'icons',
      options: {
        grid: { label: 'Grid', icon: 'icon-blokkli-option-grid' },
        slider: {
          label: 'Slider',
          icon: 'icon-blokkli-option-slider-desktop',
        },
      },
    },
  },
  globalOptions: ['spacing'],
  editor: {
    editTitle: (el) => el.querySelector('h2')?.innerText,
    addBehaviour: 'no-form',
  },
  propsFieldMapping: {
    header: 'field_header',
    paragraphs: 'field_paragraphs_teaser',
  },
})

const paragraphClassList = computed(() => {
  const classList = []

  if (options.value.spacing === 'small') {
    classList.push('pt-6', 'lg:pt-10')
  } else if (options.value.spacing === 'large') {
    classList.push('pt-12', 'lg:pt-20')
  }

  return classList
})

const isSlider = computed(() => options.value.teaserStyle === 'slider')
</script>

<style lang="postcss">
.paragraph-teaser-grid {
  @screen sm {
    @apply grid grid-cols-2 gap-gap;
    .teaser {
      @apply mb-4;
    }
  }
  @screen md {
    @apply grid-cols-3;
  }
}

.paragraph-teaser-flex {
  > div {
    @apply w-full sm:w-[calc((100%-30px)/2)] lg:w-[calc((100%-60px)/3)];
  }
}

.paragraph-teaser-slider {
  @media (max-width: calc(theme('screens.sm') - 1px)) {
    .teaser {
      @apply flex-col;
      .teaser-image {
        @apply w-full object-cover;
      }
      .teaser-arrow {
        @apply size-14 bottom-5;
        > div {
          @apply size-14;
        }
        svg {
          @apply size-10;
        }
      }
    }
  }
}
</style>
